import FeedbackModel from 'src/models/Feedback';
import BaseApi from './BaseApi';

export interface IFeedback {
    createFeedback(feedback: FeedbackModel, jwt: string): Promise<object>;
}

export default class Feedback extends BaseApi implements IFeedback {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    createFeedback = (feedback: FeedbackModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/feedback`, feedback, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Feedback.ts